import React from 'react';
import { Copy, Maximize2, Minimize2, Lock } from 'lucide-react';
import { formatTime } from '../utils/formatTime.ts';

interface HeaderProps {
  meetingId: string;
  duration: number;
  remainingSeconds?: number | null;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
  chatEncryptionEnabled?: boolean;
  mediaEncryptionEnabled?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  meetingId,
  duration,
  remainingSeconds = null,
  isFullscreen,
  onToggleFullscreen,
  chatEncryptionEnabled = false,
  mediaEncryptionEnabled = false,
}) => {
  const showCountdown = remainingSeconds != null;
  const isLowTime = showCountdown && remainingSeconds <= 5 * 60;
  const encryptionActive = chatEncryptionEnabled || mediaEncryptionEnabled;
  const copyMeetingId = () => {
    navigator.clipboard.writeText(meetingId);
    alert('Toplantı ID kopyalandı!');
  };

  const encryptionTitle = mediaEncryptionEnabled
    ? 'Sohbet ve medya (ses/görüntü/ekran) AES-256-GCM; taşıma WebRTC DTLS-SRTP'
    : 'Sohbet AES-256-GCM; medya WebRTC DTLS-SRTP';

  return (
    <div className="relative z-10 pt-[max(0.25rem,env(safe-area-inset-top))]">
      <div className="px-3 sm:px-4 py-1 sm:py-1.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0 flex-1">
          <div
            className={`inline-flex items-center gap-1.5 flex-shrink-0 ${
              isLowTime ? 'text-amber-300' : 'text-gray-200'
            }`}
            title={showCountdown ? 'Kalan süre' : 'Geçen süre'}
          >
            <span className="text-xs sm:text-sm font-mono tabular-nums">
              {showCountdown ? formatTime(remainingSeconds) : formatTime(duration)}
            </span>
            {showCountdown && (
              <span className="text-[10px] sm:text-xs text-gray-500 hidden sm:inline">kaldı</span>
            )}
          </div>

          <button
            onClick={copyMeetingId}
            className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-gray-400 hover:text-white transition min-w-0"
            title="Toplantı ID'sini kopyala"
          >
            <span className="truncate max-w-[11rem] sm:max-w-[16rem]">ID: {meetingId}</span>
            <Copy className="w-3.5 h-3.5 flex-shrink-0 opacity-70" />
          </button>
        </div>

        <div className="flex items-center gap-3 flex-shrink-0">
          {encryptionActive && (
            <span
              className="hidden sm:inline-flex items-center gap-1 text-xs text-emerald-300"
              title={encryptionTitle}
            >
              <Lock className="w-3.5 h-3.5" />
              AES-256
            </span>
          )}
          <button
            onClick={onToggleFullscreen}
            className="p-1.5 min-h-[32px] min-w-[32px] flex items-center justify-center text-white/80 hover:text-white active:scale-95 transition"
            title={isFullscreen ? 'Tam ekrandan çık' : 'Tam ekran yap'}
            aria-label={isFullscreen ? 'Tam ekrandan çık' : 'Tam ekran yap'}
          >
            {isFullscreen ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
